import { spawn } from 'redux-saga/effects';

import { sagas as currentVariety } from './currentVarietyModule';
import { sagas as changeVariety } from './changeVarietyModule';

export default function* sagas() {
	yield spawn(currentVariety);
	yield spawn(changeVariety);
}
